import React, { ComponentType, SVGProps } from 'react';
import { styled } from '@mui/material';

export type Props = {
  size?: number,
  rotation?: number,
  fill?: string,
  stroke?: string
} & SVGProps<SVGSVGElement>;

const CommonSVGIcon: ComponentType<Props> = styled('svg')(
  ({ size, rotation, fill, stroke }: Props) => ({
  width: (typeof size !== 'undefined') ? `${size}px` : '1em',
  height: (typeof size !== 'undefined') ? `${size}px` : '1em',
  stroke: stroke || 'transparent',
  fill: fill || 'currentcolor',
  ...(typeof rotation === 'number'
    ? { transform: `rotate(${rotation}deg)` }
    : {}
  )
}));

export default CommonSVGIcon;
